import { List } from '@mui/material'
import React, { useMemo } from 'react'
import TextScanEvent from './scanHistoryComponents/TextScanEvent';
import TextEvent from './scanHistoryComponents/TextEvent';
import { MachineEvent, TextEventProps } from '../../../ts/MachineEvent';
import { Machine } from '../../../ts/Connections';
import { Cargo } from '../../../ts/Cargo';
import ScanSkeleton from './scanHistoryComponents/ScanSkeleton';
import { useTranslation } from 'react-i18next';

interface ScanHistoryMobileProps {
    selectedScanIndex: number;
    setSelectedScanIndex: (index: number) => void;
    cargoResponses: Cargo[];
    machineEvents: MachineEvent[];
    setOpenScanDetails: (open: boolean) => void;
    machine: Machine;
    open: boolean;
}

function ScanHistoryMobile(props: ScanHistoryMobileProps) {
    const { selectedScanIndex, setSelectedScanIndex, cargoResponses, machineEvents, setOpenScanDetails, machine, open } = props;
    const { t } = useTranslation();

    // Create a combined timeline of machine events and scan events (and sort by timestamp)
    const timelineEvents = useMemo(() => {
        return [...machineEvents, ...cargoResponses].sort((a, b) => b.timeStamp.getTime() - a.timeStamp.getTime());
    }, [machineEvents, cargoResponses]);

    const handleListItemClick = (
        _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
    ) => {
        setSelectedScanIndex(index);
    };

    const openDetailsModal = function () {
        setOpenScanDetails(true);
    }

    return (
        <List>
            {timelineEvents.map((historyEvent, index) => {
                if (historyEvent instanceof Cargo) {
                    return (
                        // ****NOTE WHEN PASSING DOWN SINGLE SCAN RESPONSE CHANGE FROM PLURAL TO SINGULAR
                        // cargoResponses --> cargoResponse
                        <TextScanEvent key={index} cargoResponse={historyEvent} scanFailure={historyEvent.dimensionCode === "0" ? false : true}
                            cargoResponseIndex={index} handleListItemClick={handleListItemClick} selectedScanIndex={selectedScanIndex}
                            openDetailsModal={openDetailsModal} machine={machine} open={open} />

                    )
                } else if (historyEvent instanceof TextEventProps) {
                    return (
                        <TextEvent key={index} {...historyEvent}></TextEvent>
                    )
                } else if (historyEvent instanceof MachineEvent && !historyEvent.complete) {
                    return <ScanSkeleton key={index}></ScanSkeleton>
                } else {
                    return <div key={index}>{t('control.eventHistory.unknownItem')}</div>
                }
            })}
        </List>
    )
}

export default React.memo(ScanHistoryMobile);